import axiosInstance from "../../../Axios/Axios"

const addTeam=async(teamData:any)=>{
    return await axiosInstance.post('/Team/AddTeam',teamData)
    }

const addLicense=async(Data:any)=>{
    return await axiosInstance.post('/License/addLic',Data)
    }

const recoverTenant=async(Data:any)=>{
    return await axiosInstance.post('/Tenant/RecoverTenant',Data)
    }
    // 
const getAllTeams=async({queryKey}:any)=>{
    let tenantId=queryKey[1]
    return await axiosInstance.get(`/Team/GetAllTeamsByTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`)
}

const getAllTeamsByParentId=async({queryKey}:any)=>{
    let id=queryKey[1]
    return await axiosInstance.get(`/Team/GetAllTeamByParentId?id=${id}&pageIndex=1&pageSize=50000`)
}
 

const getAllActivePersonByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`/Person/GetAllActivePersonByTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`)
}
const getAllPersonByTenantId=async({queryKey}:any)=>{
let tenantId=queryKey[1];
return await axiosInstance.get(`/Person/GetAllPersonByTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`)
}
const inviteUser=async(userData:any)=>{
return axiosInstance.post('/Account/InvitedUser',userData)
}

const changeEmail=async(userData:any)=>{
    return axiosInstance.post('/Account/ChangeEmail',userData)
    }
    const changeTenantInfo=async(userData:any)=>{
        return axiosInstance.post('/Tenant/ChangeTenantInfo',userData)
        }
const changePassword=async(userData:any)=>{
    return axiosInstance.post('/Account/ChangePassword',userData)
    }

const editPerson=async({queryKey}:any)=>{
    let perId=queryKey[1];
    let tenantId=queryKey[2];
return await axiosInstance.get(`/Person/GetPersonDetailById?id=${perId}&tenantId=${tenantId}`)
}

const getTeamDetail=async({queryKey}:any)=>{
    let teamId=queryKey[1];
    return await axiosInstance.get(`/Team/GetTeamDetailsById?id=${teamId}`)

}

const GetAllUserRolesByTeamId=async({queryKey}:any)=>{
    let teamId=queryKey[1];
    return await axiosInstance.get(`/UserRole/GetAllUserRolesByTeamId?teamId=${teamId}`)
}

const GetAllRolesByTenantId=async({queryKey}:any)=>{
    let teamId=queryKey[1];
    return await axiosInstance.get(`/Account/GetAllRolesByTenantId?tenantId=${teamId}`)
}

const getKeyResultAttachment=async({queryKey}:any)=>{
    let teamId=queryKey[1];
    let meetingId=queryKey[2];
    return await axiosInstance.get(`/Meeting/GetAttachmentById?id=${teamId}&meetingId=${meetingId}`)
}

const deleteAttachment=async(delteKrBody:any)=>{
    return await axiosInstance.post(`OKR/DeleteAttachment`,delteKrBody)
}

const deailyReport=async({queryKey}:any)=>{
    let teamId=queryKey[1];
    return await axiosInstance.get(`/Tools/One`)
}

const deleteInvitedPerson=(perIds:any|null)=>{
return axiosInstance.post(`/Person/DeleteInvitedPerson`,perIds)
}
const deletePerson=async(personDeletedBody:any|null)=>{
return  await  axiosInstance.post(`/Person/DeletePerson`,personDeletedBody)
}

const deleteTenant=async(teamDeletedBody:any|null)=>{
return await axiosInstance.post(`/Tenant/DeleteTenantByUser`,teamDeletedBody)
}

const deleteTeam=async(teamDeletedBody:any|null)=>{
return await axiosInstance.post(`/Team/DeleteTeam`,teamDeletedBody)
}

const editPersonStaff=async(personEditedBody:any)=>{
return await axiosInstance.post('/Person/EditPerson',personEditedBody)
}

const editTeam=async(teamEditedBody:any)=>{
    return await axiosInstance.post('/Team/EditTeam',teamEditedBody)
}

const addBulkRoleAssignment=async(teamEditedBody:any)=>{
    return await axiosInstance.post('/UserRole/AddBulkRoleAssignment',teamEditedBody)
}

const sendSms=async(body:any)=>{
return await axiosInstance.post('/Account/SendSMS',body)
}

const checkOTP=async(body:any)=>{
    return await axiosInstance.post('/Account/CheckOTP',body)
    }

const checkExists=async(body:any)=>{
    return await axiosInstance.post('/Account/CheckExistss',body)
    }

const checkEmailExists=async(body:any)=>{
    return await axiosInstance.post('/Account/CheckEmailExists',body)
    }

const personByInvitationCode=async(body:any)=>{
    return await axiosInstance.post('/Person/PersonByInvitationCode',body)
    }
    
const getPersonByInvitationCode=async({body}:any)=>{
    let code=body[0];
    let phone=body[1];
    return await axiosInstance.get(`/Person/GetPersonByInvitationCode?invitationCode=${code}&phoneNumber=${phone}`)
}

const checkForgetCode=async(body:any)=>{
return await axiosInstance.post(`/Account/CheckForgetCode`,body)
}

const registerUserByCode=async(body:any)=>{
    return await axiosInstance.post(`/Account/RegisterUserByCode`,body)
    }

    const tenantRegister=async(body:any)=>{
        return await axiosInstance.post(`/Tenant/TenantRegister`,body)
        }

    const addNewPassWord=async(body:any)=>{
        return await axiosInstance.post(`/Account/ForgetPassword`,body)
        }
   
const getUserProfileDetail=async({queryKey}:any)=>{
    let ids=queryKey[1];
return await axiosInstance.get(`/OKR/GetUserProfileDetail/?personId=${ids.personId}&tenantId=${ids.tenantId}`)
}

const getPersonLoginByPersonId=async({queryKey}:any)=>{
return await axiosInstance.get(`/Person/GetPersonLoginByPersonId`)
}

const getTenantInfo=async({queryKey}:any)=>{
    let ids=queryKey[1];
return await axiosInstance.get(`/Tenant/GetTenantInfo/?tenantId=${ids.tenantId}`)
}

const getPersonPicture=async({queryKey}:any)=>{
let personId=queryKey[1];
return axiosInstance.get(`/Person/GetPersonPicture/?personId=${personId}`)

}

const getTenantPicture=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return axiosInstance.get(`/Tenant/GetTenantPicture/?tenantId=${tenantId}`)
    
    }

    const getAllTenantUserCount=async()=>{
        return axiosInstance.get(`/Tenant/GetAllTenantUserCount`)
        }

const addPersonPicture=async(body:any)=>{
return axiosInstance.post('/Person/AddPersonPicture',body)
}

const addTenantPicture=async(body:any)=>{
    return axiosInstance.post('/Tenant/AddTenantPicture',body)
    }
    
const addAttachment=async(body:any)=>{
    return axiosInstance.post('/Meeting/AddAttachment',body)
    }

    export{
        addTeam,
        addAttachment,
        addLicense,
        getAllTeams,
        getAllTeamsByParentId,
        getAllActivePersonByTenantId,
        getAllPersonByTenantId,
        inviteUser,
        deleteAttachment,
        editPerson,
        deleteTeam,
        deleteTenant,
        deletePerson,
        editPersonStaff,
        deleteInvitedPerson,
        getTeamDetail,
        changeTenantInfo,
        editTeam,
        sendSms,
        personByInvitationCode,
        getPersonByInvitationCode,
        recoverTenant,
        getKeyResultAttachment,
        checkForgetCode,
        registerUserByCode,
        checkOTP,
        changeEmail,
        getUserProfileDetail,
        getTenantInfo,
        getPersonPicture,
        getTenantPicture,
        getAllTenantUserCount,
        addPersonPicture,
        tenantRegister,
        addNewPassWord,
        addTenantPicture,
        GetAllUserRolesByTeamId,
        GetAllRolesByTenantId,
        changePassword,
        checkEmailExists,
        checkExists,
        deailyReport,
        getPersonLoginByPersonId,
        addBulkRoleAssignment
    }